import {
  Channel,
  QueueStatsFilterTypeDefinitionKey,
  TimeScale,
  VolumeAggregationDimension,
  VolumeAggregationDimensionExtended,
  VolumeAggregationDimensionTarget,
  VolumeComparisonType,
} from 'types'

export const ComparisonTypeLabels = {
  [VolumeComparisonType.LastWeek]: 'Inflow: Last week',
  [VolumeComparisonType.FourWeekAverage]: 'Inflow: 4-week average',
  [VolumeComparisonType.Forecasts]: 'Inflow: Forecast',
  [VolumeComparisonType.Outflow]: 'Outflow',
}

export const comparisonTypeOptions = [
  {
    label: ComparisonTypeLabels[VolumeComparisonType.LastWeek],
    key: VolumeComparisonType.LastWeek,
    value: VolumeComparisonType.LastWeek,
  },
  {
    label: ComparisonTypeLabels[VolumeComparisonType.FourWeekAverage],
    key: VolumeComparisonType.FourWeekAverage,
    value: VolumeComparisonType.FourWeekAverage,
  },
  {
    label: ComparisonTypeLabels[VolumeComparisonType.Forecasts],
    key: VolumeComparisonType.Forecasts,
    value: VolumeComparisonType.Forecasts,
  },
  {
    label: ComparisonTypeLabels[VolumeComparisonType.Outflow],
    key: VolumeComparisonType.Outflow,
    value: VolumeComparisonType.Outflow,
  },
]

const chatAggregationDimensionOptions = [
  {
    label: 'Specialisation',
    key: VolumeAggregationDimensionExtended.Specialisation,
    value: VolumeAggregationDimensionExtended.Specialisation,
  },
]

const danteAggregationDimensionOptions = [
  {
    label: 'Topic',
    key: VolumeAggregationDimensionExtended.Specialisation,
    value: VolumeAggregationDimensionExtended.Specialisation,
  },
]

export type DimensionOption = {
  label: string
  key: string
  value: VolumeAggregationDimensionExtended

  filterKey?: QueueStatsFilterTypeDefinitionKey
  filterChildKey?: VolumeAggregationDimensionExtended
}

export const aggregationDimensionOptionsMap: Record<Channel, DimensionOption[]> = {
  [Channel.Chat]: [
    ...chatAggregationDimensionOptions,
    {
      label: 'Country',
      key: VolumeAggregationDimensionExtended.Country,
      value: VolumeAggregationDimensionExtended.Country,
    },
    {
      label: 'Language',
      key: VolumeAggregationDimensionExtended.Language,
      value: VolumeAggregationDimensionExtended.Language,
    },
    {
      label: 'Pricing plan',
      key: VolumeAggregationDimensionExtended.PricingPlan,
      value: VolumeAggregationDimensionExtended.PricingPlan,
    },
    {
      label: 'CX Labs: Feature',
      key: VolumeAggregationDimensionExtended.UserProblemFeature,
      value: VolumeAggregationDimensionExtended.UserProblemFeature,
    },
    {
      label: 'CX Labs: Problem',
      key: VolumeAggregationDimensionExtended.UserProblemProblem,
      value: VolumeAggregationDimensionExtended.UserProblemProblem,
    },
    {
      label: 'Operating system',
      key: VolumeAggregationDimensionExtended.OperatingSystem,
      value: VolumeAggregationDimensionExtended.OperatingSystem,

      filterKey: QueueStatsFilterTypeDefinitionKey.DeviceBrand,
      filterChildKey: VolumeAggregationDimensionExtended.OperatingSystemVersion,
    },
    {
      label: 'Application',
      key: VolumeAggregationDimensionExtended.Application,
      value: VolumeAggregationDimensionExtended.Application,

      filterKey: QueueStatsFilterTypeDefinitionKey.DeviceAppName,
      filterChildKey: VolumeAggregationDimensionExtended.ApplicationVersion,
    },
  ],
  [Channel.Dante]: [
    ...danteAggregationDimensionOptions,
    {
      label: 'Queue',
      key: VolumeAggregationDimensionExtended.Queue,
      value: VolumeAggregationDimensionExtended.Queue,
    },
    {
      label: 'Template',
      key: VolumeAggregationDimensionExtended.TicketConfiguration,
      value: VolumeAggregationDimensionExtended.TicketConfiguration,
    },
    {
      label: 'Outcome',
      key: VolumeAggregationDimensionExtended.Outcomes,
      value: VolumeAggregationDimensionExtended.Outcomes,
    },
    {
      label: 'Required skill',
      key: VolumeAggregationDimensionExtended.RequiredSkill,
      value: VolumeAggregationDimensionExtended.RequiredSkill,
    },
  ],
}

export const xAxisLabelByTimeScale = {
  [TimeScale.Hourly]: 'HH:mm',
  [TimeScale.Daily]: 'd MMM',
  [TimeScale.Weekly]: 'd MMM',
}

export const dimensionToDimensionTargetField: Partial<
  Record<VolumeAggregationDimension, keyof VolumeAggregationDimensionTarget>
> = {
  [VolumeAggregationDimension.OperatingSystemVersion]: 'operatingSystem',
  [VolumeAggregationDimension.ApplicationVersion]: 'application',
}
